export const urlParameter = {
  get: (parameterName = null) => {
    const params = new URLSearchParams(window.location.search);
    return parameterName ? params.get(parameterName) : false;
  }
}
